import { useSyncExternalStore } from 'react'
import type { Location } from 'react-router'
import type { FeedItem, PostMeasurement } from '../api/types'

// Порядок постов в загруженной ленте: карточка листает по нему (← →, свайп).
// Лента пишет сюда при каждом изменении, карточка только читает.

let ids: number[] = []
let loadMore: (() => void) | null = null
const listeners = new Set<() => void>()
let measurements = new Map<number, PostMeasurement>()

function emit() {
  listeners.forEach((cb) => cb())
}

export function setFeedOrder(next: number[], more: (() => void) | null,
  items?: Pick<FeedItem, 'id' | 'metric_view' | 'context_source_id'>[]): void {
  loadMore = more
  measurements = new Map((items ?? []).map((item) => [item.id, {
    metric_view: item.metric_view, context_source_id: item.context_source_id ?? undefined,
  }]))
  if (next.length === ids.length && next.every((id, i) => id === ids[i])) return
  ids = next
  emit()
}

export function feedMeasurement(id: number): PostMeasurement | undefined { return measurements.get(id) }

function subscribe(cb: () => void): () => void {
  listeners.add(cb)
  return () => listeners.delete(cb)
}

export function useFeedOrder(): number[] {
  return useSyncExternalStore(subscribe, () => ids)
}

export function neighbours(order: number[], id: number): { prev: number | null; next: number | null } {
  const i = order.indexOf(id)
  if (i < 0) return { prev: null, next: null }
  return { prev: order[i - 1] ?? null, next: order[i + 1] ?? null }
}

/** Близко к концу загруженного — подгрузить следующую страницу ленты. Звать из эффекта. */
export function loadMoreNear(order: number[], id: number): void {
  const i = order.indexOf(id)
  if (i >= 0 && i >= order.length - 3) loadMore?.()
}

/** Карточка поверх ленты: лента остаётся под ней, и после закрытия прокрутка на месте. */
export interface OverlayState {
  backgroundLocation?: Location
}
